import { createSlice } from '@reduxjs/toolkit'
import { EventValues } from '../types'
// Define the type for the state
interface StateType {
    eventList: EventValues[]
    currentPage: number
    totalCount: number
}

const eventState: StateType = {
    eventList: [],
    currentPage: 1,
    totalCount: 1,
}

const googleEventSlice = createSlice({
    name: 'google_events',
    initialState: eventState,
    reducers: {
        saveEventList: (state, action) => {
            state.eventList = action.payload.data
            state.totalCount = action.payload.totalCount
            state.currentPage = action.payload.currentPage
        },
        deleteEventsFromList: (state, action) => {
            state.eventList = state.eventList.filter(
                (event: EventValues) => event.id !== action.payload.id
            )
        },
    },
})

export default googleEventSlice.reducer

export const { saveEventList, deleteEventsFromList } = googleEventSlice.actions
